import { create } from 'zustand';
export const useHistoryStore = create((set, get) => ({
    undoStack: [],
    redoStack: [],
    pushEvent: (event) => {
        set((state) => ({
            undoStack: [...state.undoStack, event],
            redoStack: [], // Clear redo stack when new event is added
            canUndo: true,
            canRedo: false,
        }));
    },
    undo: () => {
        const { undoStack, redoStack } = get();
        if (undoStack.length === 0)
            return;
        const event = undoStack[undoStack.length - 1];
        event.undo();
        const newUndoStack = undoStack.slice(0, -1);
        const newRedoStack = [...redoStack, event];
        set({
            undoStack: newUndoStack,
            redoStack: newRedoStack,
            canUndo: newUndoStack.length > 0,
            canRedo: true,
        });
    },
    redo: () => {
        const { undoStack, redoStack } = get();
        if (redoStack.length === 0)
            return;
        const event = redoStack[redoStack.length - 1];
        event.redo();
        const newRedoStack = redoStack.slice(0, -1);
        const newUndoStack = [...undoStack, event];
        set({
            undoStack: newUndoStack,
            redoStack: newRedoStack,
            canUndo: true,
            canRedo: newRedoStack.length > 0,
        });
    },
    canUndo: false,
    canRedo: false,
    clear: () => set({
        undoStack: [],
        redoStack: [],
        canUndo: false,
        canRedo: false,
    }),
}));
